import React from "react";

export default function EditCheckBox() {
  return <div>EditCheckBox</div>;
}
